import { render, staticRenderFns } from "./my.vue?vue&type=template&id=f1a09dde&scoped=true&"
import script from "./my.vue?vue&type=script&lang=js&"
export * from "./my.vue?vue&type=script&lang=js&"
import style0 from "./my.vue?vue&type=style&index=0&id=f1a09dde&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1a09dde",
  null
  
)

export default component.exports